/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-template */
/* eslint-disable no-console */
/* eslint-disable no-plusplus */
import axios from 'axios';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import Paginate from 'vuejs-paginate';
import Multiselect from 'vue-multiselect';
import apiUrl from '../../../constants';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { variables } from '../../../../config';
import moment from 'moment';
import { newAWB, RecReasonData } from '../../../services/getDataCall';
import { AWBNumberNormslization } from '../../../services/utility';

export default {
  name: 'investigationactionbyoperation',
  components: {
    BasicSelect,
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      newhubs: '',
      newhublist: [],
      show: false,
      show2: false,
      // for hun list
      hub: '',
      hublist: [],
      // for status list
      // verification Status
      vStatus: '',
      vStatusList: [],
      verification: [],
      myStr: '',
      todate: '',
      fromdate: '',
      octroi_MRP: '',
      awbnumber: '',
      accesszonelist: '',
      parsedata: '',
      operator: '',
      exportdis: '',
      editshowtable: false,
      isLoading1: false,
      StatusData: [],
      Awb: [],
      currentdateminus180: '',
      pageno: 0,
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      ListData: [],
      totalcount: 0,
      Status: '',
      recreasons:[],
      RECReasonMap: {},
      StatusList: [{
        id: 1,
        label: 'Forcefully Marked'
      }, {
        id: 2,
        label: 'Rec Marked'
      }],
    };
  },
  mounted() {
    const userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.accesszonelist = window.localStorage.getItem('accesszone');
    this.parsedata = JSON.parse(this.accesszonelist);
    this.getzonehubs();
    this.status();
    this.verificationStatusName();
    this.recReasonFetchData();
  },
  computed: {
    checkDisabled() {
      return (this.operator === '');
    },
    ExportDisableds() {
      return (this.exportdis === '');
    },
  },
  methods: {

    getzonehubs() {
      this.show = true;
      axios({
        method: 'post',
        url: `${apiUrl.api_url}getZoneList`,
        data: {},
        headers: {
          Authorization: `Bearer ${this.myStr}`,
        },
      }).then((result) => {
        this.show = false;
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.hubzoneid,
            label: hub.hubzonename,
          });
        });
        this.newhublist = finalHubData;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    callHub(newhublist) {
      this.hublist = [];

      this.getHubList(newhublist.id);
      this.hub = '';
      if (newhublist.id !== undefined) {
        this.getHubList();
      }
    },

    callVstatusList(StatusList) {
      this.vStatusList = [];
      this.verificationStatus(StatusList.id);
      this.vStatus = '';
      if (StatusList.id !== undefined) {
        this.verificationStatus();
      }
    },

    verificationStatus(id) {
      this.input = ({
        investigateshipmentstatusmasterid: id,
        investigationbuckettypeid: 1,
      });

      if (id === undefined) {
        this.vStatusList = [];
      } else {
        axios({
          method: 'post',
          url: `${apiUrl.api_url}verificationstatus`,
          data: this.input,
          headers: {
            Authorization: `Bearer ${this.myStr}`,
          },
        }).then((result) => {
          const vstatusdata = [];
          result.data.data.forEach((x) => {
            vstatusdata.push({
              id: x.investigationactionmasterid,
              label: x.actionname,
            });
          });
          this.vStatusList = vstatusdata;
        },
          (error) => {
            console.error(error);
          });
      }
    },

    gethubdropdown() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getHubdropdownlist',
        data: {},
        headers: {
          Authorization: 'Bearer ' + this.myStr,
        },
      }).then((result) => {
        const finalHubData = [];
        result.data.data.forEach((hub) => {
          finalHubData.push({
            id: hub.HubID,
            label: hub.HubName,
          });
        });
        this.hubdroplist = finalHubData;
        this.editshowtable = false;

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].currenthubid !== null
              && this.listUserData[j].currenthubid !== undefined) {
              if (this.hubdroplist[i].id === this.listUserData[j].currenthubid) {
                this.listUserData[j].currenthubname = this.hubdroplist[i].label;
              }
            }
          }
        }

        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].originhubid !== null
              && this.listUserData[j].originhubid !== undefined) {
              if (this.hubdroplist[i].id === this.listUserData[j].originhubid) {
                this.listUserData[j].originhubname = this.hubdroplist[i].label;
              }
            }
          }
        }
        for (let i = 0; i < this.hubdroplist.length; i++) {
          for (let j = 0; j < this.listUserData.length; j++) {
            if (this.listUserData[j].finaldestinationid !== null
              && this.listUserData[j].finaldestinationid !== undefined) {
              if (this.hubdroplist[i].id === this.listUserData[j].finaldestinationid) {
                this.listUserData[j].finaldestinationname = this.hubdroplist[i].label;
              }
            }
          }
        }

        this.editshowtable = true;
      },
        (error) => {
          console.error(error);
        });
    },

    status() {

      this.callVstatusList(this.StatusList);
      this.Status = this.StatusList.find(Status => Status.id === 1)

    },

    getHubList(id) {
      const finalhublist = [];
      for (let i = 0; i < this.parsedata.hubaccess.length; i++) {
        if (id === this.parsedata.hubaccess[i].HubZoneId) {
          finalhublist.push({
            id: this.parsedata.hubaccess[i].HubID,
            label: this.parsedata.hubaccess[i].HubName,
          });
          this.hublist = finalhublist;
        }
      }
    },
    verificationStatusName() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'allVerificationStatus',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        let vstatusdata = []
        result.data.data.forEach((x) => {
          vstatusdata.push({
            id: x.investigationactionmasterid,
            label: x.actionname
          })
        })
        this.verification = vstatusdata
      },
        error => {

          console.error(error)
        })

    },
    resetForm() {
      this.hub = '';
      this.newhubs = '';
      this.todate = '';
      this.fromdate = '';
      this.octroi_MRP = '';
      this.awbnumber = '';
      this.isLoading = false;
      this.editshowtable = false;
      this.isLoading1 = false;
      this.$validator.reset(); this.errors.clear();
    },

    getClientList() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'getClientList',
        data: {},
        headers: {
          Authorization: 'Bearer ' + this.myStr,
        },
      }).then((result) => {
        this.clienList = result.data.data;
        this.editshowtable = false;
        for (let j = 0; j < this.listUserData.length; j++) {
          for (let i = 0; i < this.clienList.length; i++) {
            if (this.listUserData[j].clientid !== null
              && this.listUserData[j].clientid !== undefined) {
              if (this.clienList[i].ClientMasterID === this.listUserData[j].clientid) {
                this.listUserData[j].Clientname = this.clienList[i].CompanyName;
              }
            }
          }
        }
        this.editshowtable = true;
      },
        (error) => {
          this.show = false;
          console.error(error);
        });
    },

    getregionname() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {
        for (let i = 0; i < this.newhublist.length; i++) {
          if (this.listUserData[j].hubzoneid !== null
            && this.listUserData[j].hubzoneid !== undefined) {
            if (this.newhublist[i].id === this.listUserData[j].hubzoneid) {
              this.listUserData[j].regionname = this.newhublist[i].label;
            }
          }
        }
      }
      this.editshowtable = true;
    },
    verificationStatusList() {
      this.editshowtable = false;
      for (let j = 0; j < this.listUserData.length; j++) {

        for (let i = 0; i < this.verification.length; i++) {
          if (this.listUserData[j]["actionstatuscode"] !== null && this.listUserData[j]["actionstatuscode"] != undefined) {

            if (this.verification[i]["id"] == this.listUserData[j]["actionstatuscode"]) {
              this.listUserData[j]["lastactionname"] = this.verification[i]["label"];
            }
          }
        }

      }

      this.editshowtable = true;
    },
    Statusname() {
      axios({
        method: 'post',
        url: apiUrl.api_url + 'statusforstatusnames',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.StatusList2 = result.data.data;




        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.StatusList2.length; i++) {
            if (this.listUserData[j]["status"] !== null && this.listUserData[j]["status"] != undefined) {

              if (this.StatusList2[i]["statuscode"] == this.listUserData[j]["status"]) {
                this.listUserData[j]["Statusname"] = this.StatusList2[i]["statusname"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    NewAwb(data){
      newAWB(data, this.myStr).then(result => {
        result.data.data.forEach((status) => {
          this.listUserData.forEach((data, i) => {
            if(data.shippingid === status.shippingid){
              this.listUserData[i]["newAWB"] = status.shippingid + 'REC';
              this.listUserData[i]["recreasionname"] = this.Recreasion(status.recreasonid)
            }
          });
        });
      });
    },

    Recreasion(data) {
      let RecReason;
      if(data !== null && data !== undefined){
        RecReason = this.RECReasonMap[data]
      }
      return RecReason;
    },

    recReasonFetchData(){
      RecReasonData(this.myStr).then(result => {
        this.recreasons= result.data.data;
        this.recreasons.map((reasons) => {
          this.RECReasonMap[reasons.recreasonsid] = reasons.recreason
        });
      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    buckettypecode() {

      axios({
        method: 'post',
        url: apiUrl.api_url + 'getinvestigationbuckettype',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }

      }).then(result => {
        this.ListData = result.data.data;

        this.editshowtable = false;

        for (let j = 0; j < this.listUserData.length; j++) {

          for (let i = 0; i < this.ListData.length; i++) {
            if (this.listUserData[j]["buckettypecode"] !== null && this.listUserData[j]["buckettypecode"] != undefined) {

              if (this.ListData[i]["investigatbuckettypeid"] == this.listUserData[j]["buckettypecode"]) {
                this.listUserData[j]["Buckettypename"] = this.ListData[i]["buckettypename"];

              }
            }
          }

        }

        this.editshowtable = true;

      },
        error => {
          this.show = false;
          console.error(error)
        })
    },

    // to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * variables.pageRecordLimit;
      this.searchData(this.pageno);
    },
    // searchbutton
    searchData(pageNo) {
      this.awbnumber = AWBNumberNormslization(this.awbnumber).toString();
      this.isLoading1 = true;
      this.show2 = true,
        this.listUserData = [];
      this.pagecount = 1;
      this.totalRows = '';
      this.exportdis = 1;
      this.totalcount = 0;
      let d = new Date();
      let fromDate, ToDate, IsActive;
      IsActive = false;
      let daysto = d.setDate(d.getDate() - 180);
      this.currentdateminus180 = moment(new Date(daysto)).format("YYYY-MM-DD")
      fromDate = this.currentdateminus180.slice(0, 10) + " 00:00:00";
      ToDate = this.currentdate.slice(0, 10) + " 23:59:59";

      if (this.vStatus.id) {
        const vid = this.vStatus.id;
        var vstatusid = vid.toString();
      }
      if ((this.fromdate && !this.todate) || (!this.fromdate && this.todate)) {
        this.$alertify.error("Please enter both  date")

      }
      else if (this.fromdate > this.todate) {
        this.$alertify.error("From date should not be greater than To date")

      } else if ((this.fromdate && this.todate) || (!this.fromdate && !this.todate)) {

        if ((this.fromdate != '' && this.todate != '')) {
          fromDate = this.fromdate.slice(0, 10) + " 00:00:00";
          ToDate = this.todate.slice(0, 10) + " 23:59:59";
        }

        if(this.Status.id == 1){
          IsActive = true;
        }

        this.input = ({
          offset: pageNo,
          limit: variables.pageRecordLimit,
          shippingid: this.awbnumber,
          FromDate: fromDate,
          ToDate: ToDate,
          actionstatuscode: vstatusid,
          detendeddaysfrom: this.detended_days_from,
          detendeddaysto: this.detended_days_to,
          hubzoneid: this.newhubs.id,
          currenthubid: this.hub.id,
          operator: this.operator,
          isactive: IsActive,
          //originhubid: this.hub.id,
          netvalue: this.octroi_MRP,
        });

      }
        axios({
          method: 'post',
          url: `${apiUrl.api_url}forcefullylostshipmentreport`,
          data: this.input,
          headers: {
            Authorization: `Bearer ${this.myStr}`,
          },
        }).then((result) => {
          this.show2 = false,
          this.totalcount = result.data.count?result.data.count:0
          if (this.totalcount == undefined) {
            this.totalcount = 0
          }
          this.listUserData = result.data.data;
          this.getClientList();
          this.gethubdropdown();
          this.getregionname();
          this.Statusname();
          this.buckettypecode();
          this.verificationStatusList();
          this.NewAwb(this.listUserData);
          if (this.totalRows < variables.pageRecordLimit) {
            this.pagecount = 1;
          } else {
            this.pagecount = Math.ceil(result.data.count / variables.pageRecordLimit);
          }
        });
    },


    exportfileCSV() {
      this.isLoading1 = true;
      this.downloadCSV(this.listUserData);
    },

    async downloadCSV(result) {
      var csvData = result;
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      var today = dd + '' + mm + '' + yyyy;
      var data, filename, link;
      filename = 'lost' + today + '.csv';
      var csv = await this.convertArrayOfObjectsToCSV({
        data: csvData,
      });
      if (csv == null) return;
      filename = filename || 'export.csv';
      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      data = csv;
      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
    convertArrayOfObjectsToCSV: function (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }
      //columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";
      //keys = Object.keys(data[0]).slice(0);
      columnDelimiter = "ShippingID,ClientName,OctrioMRP,hubzoneid,HubZoneName,CurrentHubName,OriginHubid,OriginHubName,DestinationHubName,DisputeSatusName,Requestfrom,CreatedBy,OrderType,PhysicalWeight,VolumetricWeight,LoggedDate,LoggedDescription,ColoaderName,BagCondition,Contents,StatusName,VerificationStatus,STDBagCondition,PendingDays,verifieddate,verifieddescription,approvaldate,approvaldescription,lastmodifiedby,ManifestInScanDate,shortagetype,bagno,recreasionname";
      result = "";
      result += columnDelimiter;
      result += lineDelimiter;
      for (let i = 0; i < data.length; i++) {
        result += (data[i].shippingid).toString()+ ',' + data[i].Clientname + ',' + data[i].netvalue + ',' + data[i].hubzoneid + ',' + data[i].hubzonename + ','  + data[i].currenthubname + ',' + data[i].originhubid + ',' + data[i].originhubname + ',' + data[i].finaldestinationname + ','  + data[i].disputstatusname + ',' + data[i].Buckettypename + ',' + data[i].createdby + ',' + data[i].ordertype + ',' +data[i].phyweight+ ',' + data[i].volweight + ',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") + ',' + data[i].loggeddescription + ',' + data[i].coloaderid + ',' + data[i].stdbagcondition + ',' + data[i].productinformation + ',' + data[i].Statusname + ',' + data[i].VerificationStatus + ',' + data[i].stdbagcondition + ',' + data[i].pendingdays + ',' + moment(new Date(data[i].verifieddate)).format("DD/MM/YYYY") + ',' + data[i].verifieddescription +',' + data[i].approvaldate + ',' + data[i].approvaldescription + ',' + data[i].lastmodifiedby +',' +  moment(new Date(data[i].createddate)).format("DD/MM/YYYY") +',' + data[i].shortagetype +',' + data[i].bagno +',' + data[i].recreasionname   ;

        result += lineDelimiter;


      }
      return result;
    },
  }
};



// WEBPACK FOOTER //
// ./src/views/components/forceFullyLostShipmentsReport/forceFullyLostShipmentsReport.component.js